<div class="row">
  <form name="form" [formGroup]="fg">
    @for (
      item of fg?.get('lineItems')['controls'];
      track item;
      let i = $index
    ) {
      <div formArrayName="lineItems">
        @if (!isDisabled) {
          <div [formGroupName]="i" class="position-relative">
            <div
              class="d-inline-block fw-500 text-1"
              [ngClass]="{ isIconShow: 'ms-2' }"
            >
              {{ 'QUOTE_TEMPLATE.Address' | translate }}
            </div>
            @if (addressRequired) {
              <span class="color-6 mt-5">*</span>
            }
            @if (needOtherFields && field_address.type?.length) {
              <div class="mobile_name row mt-2 my-2">
                <div
                  class="col-4 xs-2:!pr-0"
                  [ngClass]="{
                    'input-width': isEquoteModule,
                    'p-0': isEquoteModule,
                    'ml-3': isEquoteModule,
                  }"
                >
                  <mat-form-field
                    class="w-full"
                    appearance="outline"
                    floatLabel="always"
                    id="AddressTitleInput{{ i }}"
                    [ngClass]="{
                      'mat-error-outline': showAddressError,
                      'mat-success-outline': !showAddressError,
                    }"
                  >
                    <mat-select
                      class="text-1 w-full"
                      placeholder="Select Address Name"
                      [(ngModel)]="selectedAddress"
                      [ngModelOptions]="{ standalone: true }"
                      (ngModelChange)="changeAddField($event, 'addTitle', i)"
                    >
                      <mat-option
                        class="text-1"
                        value=""
                        style="background-color: #fafafa"
                      >
                        {{ 'CONTACT_PROFILE.select_address_name' | translate }}
                      </mat-option>

                      @for (
                        formContactList of field_address.type;
                        track formContactList;
                        let i = $index
                      ) {
                        <mat-option
                          style="background-color: #fafafa"
                          class="text-1"
                          [value]="formContactList"
                        >
                          {{ formContactList }}
                        </mat-option>
                      }
                    </mat-select>
                  </mat-form-field>
                  @if (showAddressError) {
                    <div class="text-red-600 mt-1">Address is Required</div>
                  }
                </div>
                @if (needOtherFields) {
                  <div
                    class="address-action col-4 mt-2 xs-2:!pr-0 d-flex align-items-center"
                  >
                    @if (customerAddressArr.length > 1) {
                      <button
                        class="nav-link add-btn color-4 f-w-500"
                        (click)="removeAddress(i)"
                      >
                        <i class="fas fa-times me-1"></i
                        >{{ 'COMMON.Delete_Address' | translate }}
                      </button>
                    }
                  </div>
                }
              </div>
            }
            <input
              (input)="onAddressInput($event, 'search')"
              formControlName="formattedAddress"
              style="border-color: #e1e1e1 !important"
              id="address"
              [ngStyle]="{
                'font-size': customerAddressStyle?.fontsize,
                'font-family': customerAddressStyle?.fontfamily,
                color: customerAddressStyle?.color,
              }"
              googlePlaces
              type="text"
              class="form-control address"
              [ngClass]="{ address_input: isEquoteModule }"
              placeholder="{{ 'COMMON.Type to search' | translate }}"
              [country]="fg.get('lineItems').get(i.toString()).get('country')"
              [region]="fg.get('lineItems').get(i.toString()).get('state')"
              [province]="fg.get('lineItems').get(i.toString()).get('province')"
              [city]="fg.get('lineItems').get(i.toString()).get('city')"
              [postal_code]="
                fg.get('lineItems').get(i.toString()).get('postal_code')
              "
              [street_name]="
                fg.get('lineItems').get(i.toString()).get('street_name')
              "
              [streetNumber]="
                fg.get('lineItems').get(i.toString()).get('house_number')
              "
              [latitude]="fg.get('lineItems').get(i.toString()).get('latitude')"
              [longitude]="
                fg.get('lineItems').get(i.toString()).get('longitude')
              "
              [formattedAddress]="
                fg.get('lineItems').get(i.toString()).get('formattedAddress')
              "
            />
          </div>
          @if (needOtherFields) {
            <div
              class="row"
              [formGroupName]="i"
              [ngClass]="{
                'ms-3': paddingLeft,
                'max-w-[880px]': isEquoteModule,
              }"
            >
              @for (addressform of addressFormateArrView; track addressform) {
                @if (addressform == 'Country Name') {
                  <div
                    class="col-4 mt-2 xs-2:!pr-0"
                    [ngClass]="{
                      'input-width': isEquoteModule,
                      'p-0': isEquoteModule,
                      'ml-3': isEquoteModule,
                    }"
                  >
                    <div class="font-medium resp-name-label">
                      {{ 'COMMON.Country Name' | translate }}:
                    </div>
                    <div>
                      <input
                        [id]="'country' + tempIndex"
                        class="w-full input px-2 py-2"
                        name="country"
                        formControlName="country"
                        (input)="onAddressInput($event, 'country')"
                        [ngStyle]="{
                          'font-size': customerAddressStyle?.fontsize,
                        }"
                        placeholder="{{
                          'GENRIC_PLACEHOLDER.COUNTRY' | translate
                        }}"
                      />
                    </div>
                  </div>
                }
                @if (addressform == 'City Name') {
                  <div
                    class="col-4 mt-2 xs-2:!pr-0"
                    [ngClass]="{
                      'input-width': isEquoteModule,
                      'p-0': isEquoteModule,
                      'ml-3': isEquoteModule,
                    }"
                  >
                    <div class="font-medium resp-name-label">
                      {{ 'COMMON.State' | translate }}:
                    </div>
                    <div>
                      <input
                        [id]="'state' + tempIndex"
                        class="w-full input px-2 py-2"
                        name="state"
                        formControlName="state"
                        (input)="onAddressInput($event, 'state')"
                        [ngStyle]="{
                          'font-size': customerAddressStyle?.fontsize,
                        }"
                        placeholder="{{
                          'GENRIC_PLACEHOLDER.STATE' | translate
                        }}"
                      />
                    </div>
                  </div>
                }
                @if (addressform == 'City Name') {
                  <div
                    class="col-4 mt-2 xs-2:!pr-0"
                    [ngClass]="{
                      'input-width': isEquoteModule,
                      'p-0': isEquoteModule,
                      'ml-3': isEquoteModule,
                    }"
                  >
                    <div class="font-medium resp-name-label">
                      {{ 'COMMON.City Name' | translate }}:
                    </div>
                    <div>
                      <input
                        [id]="'city' + tempIndex"
                        class="w-full input px-2 py-2"
                        name="city"
                        formControlName="city"
                        (input)="onAddressInput($event, 'city')"
                        [ngStyle]="{
                          'font-size': customerAddressStyle?.fontsize,
                        }"
                        placeholder="{{
                          'GENRIC_PLACEHOLDER.CITY' | translate
                        }}"
                      />
                    </div>
                  </div>
                }
                @if (addressform == 'Postal Code') {
                  <div
                    class="col-4 mt-2 xs-2:!pr-0"
                    [ngClass]="{
                      'input-width': isEquoteModule,
                      'p-0': isEquoteModule,
                      'ml-3': isEquoteModule,
                    }"
                  >
                    <div class="font-medium resp-name-label">
                      {{ 'COMMON.Postal Code' | translate }}:
                    </div>
                    <div>
                      <input
                        [id]="'postal_code' + tempIndex"
                        class="w-full input px-2 py-2"
                        name="postal_code"
                        formControlName="postal_code"
                        (input)="onAddressInput($event, 'postal_code')"
                        [ngStyle]="{
                          'font-size': customerAddressStyle?.fontsize,
                        }"
                        placeholder="{{ 'COMMON.Postal Code' | translate }}"
                      />
                    </div>
                  </div>
                }
                @if (addressform == 'Street Name') {
                  <div
                    class="col-4 mt-2 xs-2:!pr-0"
                    [ngClass]="{
                      'input-width': isEquoteModule,
                      'p-0': isEquoteModule,
                      'ml-3': isEquoteModule,
                    }"
                  >
                    <div class="font-medium resp-name-label">
                      {{ 'COMMON.Street Name' | translate }}:
                    </div>
                    <div>
                      <input
                        [id]="'street_name' + tempIndex"
                        class="w-full input px-2 py-2"
                        name="street_name"
                        formControlName="street_name"
                        (input)="onAddressInput($event, 'street_name')"
                        [ngStyle]="{
                          'font-size': customerAddressStyle?.fontsize,
                        }"
                        placeholder="{{ 'COMMON.Street Name' | translate }}"
                      />
                    </div>
                  </div>
                }
                @if (addressform == 'House Number') {
                  <div
                    class="col-4 mt-2 xs-2:!pr-0"
                    [ngClass]="{
                      'input-width': isEquoteModule,
                      'p-0': isEquoteModule,
                      'ml-3': isEquoteModule,
                    }"
                  >
                    <div class="font-medium resp-name-label">
                      {{ 'COMMON.House Number' | translate }}:
                    </div>
                    <div>
                      <input
                        [id]="'house_number' + tempIndex"
                        class="w-full input px-2 py-2 house_number"
                        name="house_number"
                        formControlName="house_number"
                        (input)="onAddressInput($event, 'house_number')"
                        [ngStyle]="{
                          'font-size': customerAddressStyle?.fontsize,
                        }"
                        placeholder="{{ 'COMMON.House Number' | translate }}"
                      />
                    </div>
                  </div>
                }
                @if (addressform == 'Interior Number') {
                  <div
                    class="col-4 mt-2 xs-2:!pr-0 w-max"
                    [ngClass]="{
                      'input-width': isEquoteModule,
                      'p-0': isEquoteModule,
                      'ml-3': isEquoteModule,
                    }"
                  >
                    <div class="font-medium resp-name-label">
                      {{ 'COMMON.Interior Number' | translate }}:
                    </div>
                    <div>
                      <input
                        [id]="'interior_number' + tempIndex"
                        class="w-full input px-2 py-2"
                        name="interior_number"
                        formControlName="interior_number"
                        (input)="onAddressInput($event, 'interior_number')"
                        [ngStyle]="{
                          'font-size': customerAddressStyle?.fontsize,
                        }"
                        placeholder="{{ 'COMMON.Interior Number' | translate }}"
                      />
                    </div>
                  </div>
                }
              }
            </div>
          }
          @if (showAddressError) {
            <div class="text-red-600">Address is Required</div>
          }
        }

        @if (isDisabled) {
          <div [formGroupName]="i" class="position-relative">
            <input
              disabled="true"
              style="border-color: #e1e1e1 !important"
              formControlName="formattedAddress"
              id="address"
              [ngStyle]="{
                'font-size': customerAddressStyle?.fontsize,
                'font-family': customerAddressStyle?.fontfamily,
                color: customerAddressStyle?.color,
              }"
              googlePlaces
              type="text"
              class="form-control"
              [ngClass]="{ address_input: isEquoteModule }"
              placeholder="{{ 'Type to search' }}"
              [country]="fg.get('lineItems').get(i.toString()).get('country')"
              [region]="fg.get('lineItems').get(i.toString()).get('state')"
              [province]="fg.get('lineItems').get(i.toString()).get('province')"
              [city]="fg.get('lineItems').get(i.toString()).get('city')"
              [postal_code]="
                fg.get('lineItems').get(i.toString()).get('postal_code')
              "
              [street_name]="
                fg.get('lineItems').get(i.toString()).get('street_name')
              "
              [streetNumber]="
                fg.get('lineItems').get(i.toString()).get('house_number')
              "
              [latitude]="fg.get('lineItems').get(i.toString()).get('latitude')"
              [longitude]="
                fg.get('lineItems').get(i.toString()).get('longitude')
              "
              [formattedAddress]="
                fg.get('lineItems').get(i.toString()).get('formattedAddress')
              "
            />
          </div>
          @if (needOtherFields) {
            <div
              class="row"
              [formGroupName]="i"
              [ngClass]="{
                'ms-3': paddingLeft,
                'max-w-[880px]': isEquoteModule,
              }"
            >
              @for (addressform of addressFormateArrView; track addressform) {
                @if (addressform == 'Country Name') {
                  <div
                    class="col-4 mt-2 xs-2:!pr-0"
                    [ngClass]="{
                      'input-width': isEquoteModule,
                      'p-0': isEquoteModule,
                      'ml-[1.5rem]': isEquoteModule,
                    }"
                  >
                    <p
                      class="d-inline-block align-top mb-0"
                      [ngStyle]="{
                        'font-size': customerAddressStyle?.fontsize,
                        'font-family': customerAddressStyle?.fontfamily,
                        color: customerAddressStyle?.color,
                      }"
                    >
                      {{ 'COMMON.Country Name' | translate }}
                    </p>
                    <div>
                      <input
                        disabled="true"
                        id="country"
                        class="form-control"
                        name="country"
                        formControlName="country"
                        [ngStyle]="{
                          'border-color': customerAddressStyle?.bordercolor,
                          'font-size': customerAddressStyle?.fontsize,
                          'font-family': customerAddressStyle?.fontfamily,
                          color: customerAddressStyle?.color,
                        }"
                        placeholder="{{
                          'GENRIC_PLACEHOLDER.COUNTRY' | translate
                        }}"
                      />
                    </div>
                  </div>
                }
                @if (addressform == 'City Name') {
                  <div
                    class="col-4 mt-2 px-0"
                    [ngClass]="{ 'input-width': isEquoteModule }"
                  >
                    <p
                      class="d-inline-block align-top mb-0"
                      [ngStyle]="{
                        'font-size': customerAddressStyle?.fontsize,
                        'font-family': customerAddressStyle?.fontfamily,
                        color: customerAddressStyle?.color,
                      }"
                    >
                      {{ 'COMMON.State' | translate }}
                    </p>
                    <div>
                      <input
                        disabled="true"
                        id="state"
                        class="form-control"
                        name="state"
                        formControlName="state"
                        [ngStyle]="{
                          'border-color': customerAddressStyle?.bordercolor,
                          'font-size': customerAddressStyle?.fontsize,
                          'font-family': customerAddressStyle?.fontfamily,
                          color: customerAddressStyle?.color,
                        }"
                        placeholder="{{
                          'GENRIC_PLACEHOLDER.STATE' | translate
                        }}"
                      />
                    </div>
                  </div>
                }
                @if (addressform == 'City Name') {
                  <div
                    class="col-4 mt-2 xs-2:!pr-0"
                    [ngClass]="{ 'input-width': isEquoteModule }"
                  >
                    <p
                      class="d-inline-block align-top mb-0"
                      [ngStyle]="{
                        'font-size': customerAddressStyle?.fontsize,
                        'font-family': customerAddressStyle?.fontfamily,
                        color: customerAddressStyle?.color,
                      }"
                    >
                      {{ 'COMMON.City Name' | translate }}
                    </p>
                    <div>
                      <input
                        disabled="true"
                        id="city"
                        class="form-control"
                        name="city"
                        formControlName="city"
                        [ngStyle]="{
                          'border-color': customerAddressStyle?.bordercolor,
                          'font-size': customerAddressStyle?.fontsize,
                          'font-family': customerAddressStyle?.fontfamily,
                          color: customerAddressStyle?.color,
                        }"
                        placeholder="{{
                          'GENRIC_PLACEHOLDER.CITY' | translate
                        }}"
                      />
                    </div>
                  </div>
                }
                @if (addressform == 'Postal Code') {
                  <div
                    class="col-4 mt-2 xs-2:!pr-0"
                    [ngClass]="{ 'input-width': isEquoteModule }"
                  >
                    <p class="d-inline-block align-top mb-0">
                      {{ 'COMMON.Postal Code' | translate }}
                    </p>
                    <div>
                      <input
                        disabled="true"
                        id="postal_code"
                        class="form-control"
                        name="postal_code"
                        formControlName="postal_code"
                        [ngStyle]="{
                          'border-color': customerAddressStyle?.bordercolor,
                          'font-size': customerAddressStyle?.fontsize,
                          'font-family': customerAddressStyle?.fontfamily,
                          color: customerAddressStyle?.color,
                        }"
                        placeholder="{{ 'COMMON.Postal Code' | translate }}"
                      />
                    </div>
                  </div>
                }
                @if (addressform == 'Street Name') {
                  <div
                    class="col-4 mt-2 xs-2:!pr-0 w-max"
                    [ngClass]="{ 'input-width': isEquoteModule }"
                  >
                    <p
                      class="d-inline-block align-top mb-0"
                      [ngStyle]="{
                        'font-size': customerAddressStyle?.fontsize,
                        'font-family': customerAddressStyle?.fontfamily,
                        color: customerAddressStyle?.color,
                      }"
                    >
                      {{ 'COMMON.Interior Number' | translate }}
                    </p>
                    <div>
                      <input
                        disabled="true"
                        id="street_name"
                        class="form-control"
                        name="street_name"
                        formControlName="street_name"
                        [ngStyle]="{
                          'border-color': customerAddressStyle?.bordercolor,
                          'font-size': customerAddressStyle?.fontsize,
                          'font-family': customerAddressStyle?.fontfamily,
                          color: customerAddressStyle?.color,
                        }"
                        placeholder="{{ 'COMMON.Interior Number' | translate }}"
                      />
                    </div>
                  </div>
                }
                @if (addressform == 'House Number') {
                  <div
                    class="col-4 mt-2 xs-2:!pr-0"
                    [ngClass]="{ 'input-width': isEquoteModule }"
                  >
                    <p
                      class="d-inline-block align-top mb-0"
                      [ngStyle]="{
                        'font-size': customerAddressStyle?.fontsize,
                        'font-family': customerAddressStyle?.fontfamily,
                        color: customerAddressStyle?.color,
                      }"
                    >
                      {{ 'COMMON.House Number' | translate }}
                    </p>
                    <div>
                      <input
                        disabled="true"
                        id="house_number"
                        class="form-control"
                        name="house_number"
                        formControlName="house_number"
                        [ngStyle]="{
                          'border-color': customerAddressStyle?.bordercolor,
                          'font-size': customerAddressStyle?.fontsize,
                          'font-family': customerAddressStyle?.fontfamily,
                          color: customerAddressStyle?.color,
                        }"
                        placeholder="{{ 'COMMON.House Number' | translate }}"
                      />
                    </div>
                  </div>
                }
                @if (addressform == 'Interior Number') {
                  <div
                    class="col-4 mt-2 px-0"
                    [ngClass]="{ 'input-width': isEquoteModule }"
                  >
                    <p
                      class="d-inline-block align-top mb-0 w-max"
                      [ngStyle]="{
                        'font-size': customerAddressStyle?.fontsize,
                        'font-family': customerAddressStyle?.fontfamily,
                        color: customerAddressStyle?.color,
                      }"
                    >
                      {{ 'COMMON.Interior Number' | translate }}
                    </p>
                    <div>
                      <input
                        disabled="true"
                        id="interior_number"
                        class="form-control"
                        name="interior_number"
                        formControlName="interior_number"
                        [ngStyle]="{
                          'border-color': customerAddressStyle?.bordercolor,
                          'font-size': customerAddressStyle?.fontsize,
                          'font-family': customerAddressStyle?.fontfamily,
                          color: customerAddressStyle?.color,
                        }"
                        placeholder="{{ 'COMMON.Interior Number' | translate }}"
                      />
                    </div>
                  </div>
                }
              }
            </div>
          }
        }
      </div>
    }
  </form>

  @if (needOtherFields) {
    <div class="address-action">
      <button
        style="background: transparent; border: none"
        type="button"
        class="add-btn add-btn-plain-link mt-3 add-address"
        (click)="addAdditionalAddress($event)"
      >
        <i class="fas fa-plus-circle me-1"></i>
        {{ 'COMMON.Add_Additional_Address' | translate }}
      </button>
    </div>
  }
</div>
